import { Component } from '@angular/core';
import { ActionResult, NtapGlobalConstants, Util } from '@ntap/core';
import { map, Observable } from 'rxjs';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';
import { isDisabledActionForNerazvrstano } from '@app/shared/util/jedinica-gradiva-security-utils';

@Component({
  selector: 'app-lock-unlock-list-items-action',
  templateUrl: './lock-unlock-list-items-action.component.html',
  styleUrls: ['./lock-unlock-list-items-action.component.scss']
})
export class LockUnlockListItemsActionComponent extends ItemsListActionComponent {
  allSelectedLocked = true;
  allSelectedUnlocked = true;

  protected override initDisabledObservable() {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        this.allSelectedLocked = selectedItems.every((item: any) => {
          const mainType =
            item[NtapGlobalConstants.ATTR_$itemType] ||
            item[NtapGlobalConstants.ATTR_$mainType];
          const statusValue = item[Util.getFullAttrName(mainType, 'locked')];
          return statusValue === true;
        });
        this.allSelectedUnlocked = selectedItems.every((item: any) => {
          const mainType =
            item[NtapGlobalConstants.ATTR_$itemType] ||
            item[NtapGlobalConstants.ATTR_$mainType];
          const statusValue = item[Util.getFullAttrName(mainType, 'locked')];
          return !statusValue;
        });

        this.action.icon = this.allSelectedLocked ? 'lock-open' : 'lock';
        return (
          selectedItems.length <= 0 ||
          !(this.allSelectedLocked || this.allSelectedUnlocked) ||
          isDisabledActionForNerazvrstano(selectedItems)
        );
      })
    );
  }

  getDescription() {
    return this.allSelectedLocked ? 'Otključaj' : 'Zaključaj';
  }

  public override doExecute(): Observable<ActionResult> {
    const allSelectedLockedString = this.allSelectedLocked ? 'true' : 'false';
    return super.doExecuteWithParams({
      $lock: allSelectedLockedString
    });
  }
}
